import React from 'react';
class SiteSuptErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        //console.log('Error', error);
        //console.log('Error Details', errorInfo);
    }

    render() {
        let host = window.location.host;
        let env = (host === 'www.sitesupt.com:8442' || host.indexOf('localhost') !== -1) ? 'DEV' :
            host === 'www.sitesupt.com:8443' ? 'QA' :
                host === 'www.sitesupt.com:8444' ? 'STAGE' : '';
        if (this.state.hasError && (env !== 'DEV')) {
            window.location = window.location.origin + '/page-error';
            return "";
        } else {
            return this.props.children;
        }
    }
}

export default SiteSuptErrorBoundary;